import { render, staticRenderFns } from "./photograph-list.vue?vue&type=template&id=3c4bd188&scoped=true"
import script from "./photograph-list.vue?vue&type=script&lang=js"
export * from "./photograph-list.vue?vue&type=script&lang=js"
import style0 from "./photograph-list.vue?vue&type=style&index=0&id=3c4bd188&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4bd188",
  null
  
)

export default component.exports